import { collectiveService } from "@/common/api.service"

const initialStates = {
    status: 'loading',
    settings_status: 'loading',
    form_data: {},
    gateways: [],
    general_settings: {},
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    loadingSettings(state) {
        state.settings_status = 'loading'
    },
    success(state, gateways) {
        state.status   = 'success'
        state.gateways = gateways
    },
    successShop(state, form_data) {
        state.status   = 'successShop'
        state.form_data = form_data
    },
    successSettings(state, general_settings) {
        state.settings_status  = 'success'
        state.general_settings = general_settings
    }
}

const getters = {
    status: ({status}) => status,
    gateways: ({gateways}) => gateways,
    settings_status: ({settings_status}) => settings_status,
    form_data: ({form_data}) => form_data,
    general_settings: ({general_settings}) => general_settings,
}

const actions = {
    fetch({commit}) {
        commit('loading')
        return collectiveService.fetch().then(response => {
            commit('success', response.data.data.data)
        })
    },
    fetchGeneralSettings({commit}) {
        commit('loadingSettings')
        return collectiveService.fetchGeneralSettings().then(response => {
            commit('successSettings', response.data.data)
        })
    },
    find({commit}, hashid) {
        commit('loading')
        return collectiveService.find(hashid).then(response => {
            commit('successShop', response.data.data)
        })
    },
    findGate({commit}, hashid) {
        commit('loading')
        return collectiveService.findGate(hashid).then(response => {
            commit('successShop', response.data.data)
        })
    },
    findByShopId({commit}, params) {
        commit('loading')
        return collectiveService.findByShopId(params).then(response => {
            commit('successShop', response.data.data)
        })
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}